import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { FiMessageSquare, FiCode, FiSend, FiTrendingUp } from 'react-icons/fi';

const steps = [
  { icon: FiMessageSquare, title: 'Tell Us Your Goals', desc: 'We start with a quick chat to understand your business and needs.' },
  { icon: FiCode, title: 'We Build Your Solution', desc: 'Our team designs, develops, and configures everything for you.' },
  { icon: FiSend, title: 'Launch & Support', desc: 'We deploy your project and provide comprehensive training.' },
  { icon: FiTrendingUp, title: 'Grow With Us', desc: 'Enjoy ongoing support, maintenance, and strategic advice.' },
];

const Process = () => {
  return (
    <section id="process" className="py-24 bg-slate-50 relative overflow-hidden">
      {/* Dev Label */}
      <div className="absolute top-8 left-8 z-50">
        <span className="text-[10px] font-mono tracking-widest text-slate-400 uppercase border border-slate-200 px-2 py-1 rounded">SECTION 2 — Our Workflow</span>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">How It Works</h2>
          <p className="text-lg text-slate-600">A simple, transparent process from idea to execution.</p>
        </div>
        
        <div className="grid md:grid-cols-4 gap-8 relative">
          {/* Connector Line */}
          <div className="hidden md:block absolute top-1/2 left-0 w-full h-0.5 bg-slate-200 -z-10 -translate-y-12"></div>
          
          {steps.map((step, index) => (
            <motion.div 
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.2 }}
              className="relative flex flex-col items-center text-center group"
            >
              <div className="w-16 h-16 rounded-full bg-white shadow-md border-4 border-slate-50 flex items-center justify-center text-blue-600 mb-6 group-hover:scale-110 group-hover:border-blue-100 transition-all duration-300">
                <SafeIcon icon={step.icon} className="w-6 h-6" />
              </div>
              <div className="text-sm font-bold text-slate-400 mb-2">STEP {index + 1}</div>
              <h3 className="text-xl font-bold mb-3">{step.title}</h3>
              <p className="text-slate-600">{step.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;